module.exports = __webpack_public_path__ + "static/media/envelope.d4c42e8e.svg";